const contactStore = {
    contacts: [],
    loading: false,
    error: null,
};

export default contactStore;
